import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=4f4ef476&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=4f4ef476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ef476",
  null
  
)

export default component.exports